module.exports = __webpack_public_path__ + "static/media/icon_01.ab7eb01c.png";